import { render } from "./Funcionario.vue?vue&type=template&id=3ec41f25&scoped=true"
import script from "./Funcionario.vue?vue&type=script&lang=js"
export * from "./Funcionario.vue?vue&type=script&lang=js"

import "./Funcionario.vue?vue&type=style&index=0&id=3ec41f25&scoped=true&lang=css"

import exportComponent from "/home/devnote/Documentos/Features/Home Creditall/site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ec41f25"]])

export default __exports__